import LayerRow from "../sidebar/LayerRow";
import AbstractProvidedClass from "./AbstractProvidedClass";

export default class Layer extends AbstractProvidedClass {
    _elements = [];

    constructor(provider, { id = '', name = '', opacity = 1, visible = 1 } = {}) {
        super(provider);
        this.id = id;
        this.name = name;
        this.opacity = opacity;
        this.visible = visible;

        this.row = new LayerRow(this.provider, this);
    }

    addElement(element) {
        if (!this._elements.includes(element)) this._elements.push(element);
        this.row.updateCount();
        return this;
    }

    removeElement(element) {
        this._elements = this._elements.filter(e => e != element);
        this.row.updateCount();
        return this;
    }

    getElements() {
        return this._elements;
    }

    select() {
        if (!this._elements) return;
        this.selection.select(this._elements);
    }

    export() {
        return { id: this.id, name: this.name, opacity: this.opacity, visible: this.visible };
    }
}